// extracted by mini-css-extract-plugin
export default {"main":"EmptyChatBox_main__KWfGO"};